/**
 * Skoler der må se indstillingen "Lokalpulje fra årsnorm" i Deaktiver puljer-modalen.
 * Tilføj school_id når indstillingen skal udrulles til en skole.
 */
export const SCHOOL_IDS_ASSIGNED_POOL_NORM_WHEN_POOLS_DEACTIVATED = [63782, 62084]

export const ASSIGNED_POOL_FROM_NORM_SETTING_KEY = 'assignedPoolHoursFromNormWhenPoolsDeactivated'

export function schoolCanConfigureAssignedPoolNormWhenPoolsDeactivated (schoolId) {
  if (schoolId == null) {
    return false
  }
  const id = Number(schoolId)
  return SCHOOL_IDS_ASSIGNED_POOL_NORM_WHEN_POOLS_DEACTIVATED.indexOf(id) > -1
}

export function isAssignedPoolFromNormWhenPoolsDeactivated (schoolSettings) {
  if (!schoolSettings || !schoolSettings.deactivatePools) {
    return false
  }
  return !!schoolSettings[ASSIGNED_POOL_FROM_NORM_SETTING_KEY]
}

function effectiveDeactivatePools (version, schoolSettings) {
  const scd = version && version.overview && version.overview.school_custom_data
  if (scd && typeof scd.deactivatePools === 'boolean') {
    return scd.deactivatePools
  }
  return !!(schoolSettings && schoolSettings.deactivatePools)
}

export function effectiveAssignedPoolFromNormWhenPoolsDeactivated (version, schoolSettings) {
  if (!effectiveDeactivatePools(version, schoolSettings)) {
    return false
  }
  const scd = version && version.overview && version.overview.school_custom_data
  if (scd && typeof scd[ASSIGNED_POOL_FROM_NORM_SETTING_KEY] === 'boolean') {
    return scd[ASSIGNED_POOL_FROM_NORM_SETTING_KEY]
  }
  return isAssignedPoolFromNormWhenPoolsDeactivated(schoolSettings)
}

export function isPoolHoursEditableWhenPoolsDeactivated (type, schoolSettings) {
  if (type === 'substitute_pool_hours') {
    return true
  }
  if (type === 'assigned_pool_hours' && isAssignedPoolFromNormWhenPoolsDeactivated(schoolSettings)) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/assignedPoolWhenPoolsDeactivated.js